import Vue from 'vue'
import VueRouter from 'vue-router'
import organizationRouter from "./organizationRouter";
import branchRouter from "./branchRouter";
import memberRouter from "./memberRouter";
import {browserRedirect} from "@/utils/utils";
import {MOBILE_HOSTPATH} from "@/config";
import store from "@/store/index";

Vue.use(VueRouter)

const routes = [
    {
        path: '*',
        redirect: () => {
            return '/organization'
        }
    },
    {
        path: '/',
        redirect: () => {
            return '/organization'
        }
    },
    {
        path: '/login',
        component: () =>
            import ('../views/login'),
        meta: {
            title: '登录',
            isLogin: true // 是否需要登录才能访问
        }
    },
    {
        path: '/version',
        component: () =>
            import ('../views/version'),
        meta: {
            title: '版本更新',
            isLogin: false // 是否需要登录才能访问
        }
    },
    {
        path: '/tiaoz',
        component: () =>
            import ('../views/tiaoz'),
        meta: {
            title: '登录',
            isLogin: true // 是否需要登录才能访问
        }
    },
    {
        path: '/thirdparty',
        component: () =>
            import ('../views/thirdparty'),
        meta: {
            title: '登录',
            isLogin: false // 是否需要登录才能访问
        }
    },
    {
        path: '/forget',
        component: () =>
            import ('../views/forget'),
        meta: {
            title: '忘记密码',
        }
    },
    {
        path: '/invitation/:id',
        component: () =>
            import ('../views/invitation'),
        meta: {
            title: '会员邀请',
        }
    },
    {
        path: '/binvitation/:id',
        component: () =>
            import ('../views/binvitation'),
        meta: {
            title: '分支机构邀请',
        }
    },
    {
        path: '/organization',
        component: () =>
            import ('../views/organization/home'),
        children: organizationRouter,
    },
    {
        path: '/branch',
        component: () =>
            import ('../views/branch/home'),
        children: branchRouter,
    },
    {
        path: '/member',
        component: () =>
            import ('../views/member/home'),
        children: memberRouter,
    },
    {
        path: '/choice',
        component: () =>
            import ('../views/sonChiose'),
        meta: {
            title: '会员管理系统',
        }
    },
    {
        path: '/digitalize',
        meta: {
            title: '会员管理数据大屏',
            needLogin: false // 是否需要登录才能访问
        },
        component: () => import('../views/digitalize'),
    },
    {
        path: '/help',
        meta: {
            title: '帮助中心',
            needLogin: false // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/help'),
    }

]

const router = new VueRouter({
    routes,
    base: process.env.BASE_URL,
    mode: 'history',
    scrollBehavior(to, from, savePosition) {
        if (savePosition) {
            //解决页面从列表页跳转到详情页返回,初始在原来位置
            return savePosition;
        } else {
            //解决页面跳转后页面高度和前一个页面高度一样
            return {x: 0, y: 0};
        }
    }
})
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

router.beforeEach((to, from, next) => {
    // 因为导航守卫会比 created 更早触发，所以要先获取本地数据
    let _user = window.localStorage.getItem("user")
    let user = _user && _user !== 'undefined' ? JSON.parse(_user) : '';
    let paths = to.path.split('/')
    if (browserRedirect() === 1) {
        //跳转到 手机端
        const _query = Object.keys(to.query)
            .reduce((ary, key) => {
                if (to.query[key]) {
                    ary.push(encodeURIComponent(key) + '=' + encodeURIComponent(to.query[key]));
                }
                return ary;
            }, Object.keys(to.params)
                .reduce((ary, key) => {
                    if (to.params[key]) {
                        ary.push(encodeURIComponent(key) + '=' + encodeURIComponent(to.params[key]));
                    }
                    return ary;
                }, []))
            .join('&')
        if (to.path.indexOf('login')!==-1) window.location.href = `${MOBILE_HOSTPATH}login/login?${_query}`
        else if (to.path.indexOf('choice')!==-1) window.location.href = `${MOBILE_HOSTPATH}login/choice?${_query}`
        else if (to.path.indexOf('/invitation/')!==-1) window.location.href = `${MOBILE_HOSTPATH}pages/invitation?${_query}`
        else if (to.path.indexOf('tiaoz')!==-1 || to.path.indexOf('thirdparty') !==-1) next()
        else window.location.href = MOBILE_HOSTPATH

    } else {
        if (to.meta.isLogin) {
            window.localStorage.clear()
            store.dispatch('LogOut')
            next()
        } else {
            if ((to.meta.needLogin && user) || !to.meta.needLogin) {
                let index = -1
                switch (Number(user ? user.type : 100)) {//普通用户
                    case 1 :
                        index = paths.indexOf('organization') & paths.indexOf('branch')
                        if (index !== -1) {
                            paths[index] = 'member'
                        }
                        break
                    case 2 ://机构
                    case 4 :
                        index = paths.indexOf('member')
                        if (index !== -1) {
                            paths[index] = 'organization'
                        }
                        break
                    case 3 ://分支机构
                        index = paths.indexOf('organization') & paths.indexOf('member')
                        if (index !== -1) {
                            paths[index] = 'branch'
                        }
                        break
                }
                let rePath = paths.join('/')
                if (rePath === to.path) {
                    next()
                } else {
                    next({
                        path: rePath,
                        params: to.params,
                        query: to.query
                    })
                }
            } else {
                next({
                    path: '/login',
                    params: to.params,
                    query: to.query
                })
            }
        }

    }
});

export default router
